export const FAQ_GROUPS = [
  {
    heading: "About Just Call Paul",
    items: [
      {
        q: "What areas does Just Call Paul serve?",
        a: "Just Call Paul serves homeowners throughout Citrus County, Hernando County, and The Villages, Florida. Our service area includes communities such as Inverness, Floral City, Crystal River, Homosassa, Lecanto, Brooksville, and Spring Hill.",
        link: { to: "/service-areas", label: "See all areas we serve" },
      },
      {
        q: "Is Just Call Paul veteran-owned?",
        a: "Yes! Just Call Paul is proudly veteran-owned and operated. We believe in dependable service, attention to detail, and treating every customer's property with care.",
        link: { to: "/about", label: "Read Paul's story" },
      },
      {
        q: "Why choose Just Call Paul?",
        a: "Just Call Paul combines pressure washing, handyman services, painting, flooring, and property maintenance under one locally operated, veteran-owned business. Our goal is to make property upkeep simpler with one dependable point of contact.",
      },
    ],
  },
  {
    heading: "Pressure Washing & Exterior Cleaning",
    items: [
      {
        q: "What pressure washing services do you offer?",
        a: "We provide residential pressure washing for driveways, sidewalks, patios, lanais, and other exterior surfaces. We also offer soft washing for surfaces that require a gentler cleaning approach.",
        link: { to: "/pressure-washing", label: "Explore pressure washing & exterior cleaning" },
      },
      {
        q: "What's the difference between pressure washing and soft washing?",
        a: "Pressure washing uses higher water pressure to clean durable surfaces such as concrete. Soft washing uses lower pressure and appropriate cleaning solutions to clean more delicate exterior materials. We select the cleaning approach based on the surface and its condition.",
      },
      {
        q: "How much does pressure washing cost?",
        a: "Pricing depends on the size of the area, surface type, buildup, and accessibility. You can use our website's instant estimator to get a quick preliminary estimate for your project.",
        link: { to: "/estimate", label: "Try the instant estimator" },
      },
      {
        q: "Do you clean roofs and gutters?",
        a: "Yes. We offer roof cleaning and gutter cleaning services. The appropriate cleaning method depends on the roof material, condition, and accessibility.",
      },
      {
        q: "Do you clean pool areas and lanais?",
        a: "Yes! We clean patios, lanais, and suitable exterior surfaces around pool areas to remove accumulated dirt and buildup.",
      },
    ],
  },
  {
    heading: "Handyman, Painting, Flooring & More",
    items: [
      {
        q: "Do you offer handyman services?",
        a: "Yes. Just Call Paul handles a variety of residential handyman projects, including general repairs, installations, maintenance, and smaller home improvement jobs. Contact us with details about your project.",
        link: { to: "/handyman-services", label: "See handyman services" },
      },
      {
        q: "Do you offer interior and exterior painting?",
        a: "Yes. We provide residential interior and exterior painting services, including walls, trim, doors, and suitable exterior surfaces.",
        link: { to: "/painting-services", label: "See painting services" },
      },
      {
        q: "Do you install flooring?",
        a: "Yes. We offer residential flooring installation and replacement, including luxury vinyl plank, laminate, and other flooring options depending on the project.",
        link: { to: "/flooring-installation", label: "See flooring installation" },
      },
      {
        q: "Do you provide window cleaning?",
        a: "Yes. We offer interior and exterior residential window cleaning to remove dust, fingerprints, dirt, and outdoor buildup.",
      },
      {
        q: "Do you clean garbage and recycling bins?",
        a: "Trash can cleaning is among our listed services. Customers can contact us to confirm current availability and request pricing.",
        link: { to: "/contact", label: "Ask about trash-bin cleaning" },
      },
    ],
  },
  {
    heading: "Estimates & Scheduling",
    items: [
      {
        q: "Can I get an estimate without calling?",
        a: "Yes! Our website includes an instant estimator where you can enter information about your project and receive a preliminary estimate online.",
        link: { to: "/estimate", label: "Get an instant estimate" },
      },
      {
        q: "How do I schedule a service?",
        a: "Contact Just Call Paul by phone, text, or through the website to discuss your project, confirm availability, and arrange service.",
        link: { to: "/schedule", label: "Request a free on-site estimate" },
      },
    ],
  },
];

export const FAQ_PREVIEW = [
  FAQ_GROUPS[0].items[0],
  FAQ_GROUPS[1].items[1],
  FAQ_GROUPS[3].items[0],
  FAQ_GROUPS[0].items[2],
];
